import { memo, useMemo } from 'react'

import { Table, Text } from '@domain-group/suit-theme'

import type { AgencyModel } from '@models/types'
import AgenciesTableActions from './AgencyActionsDropdown'

const buildColumns = () => [
  {
    title: 'Title',
    dataKey: 'title',
    render: (title: string) => (
      <Text variant="ellipsis">
        {title}
      </Text>
    ),
  },
  {
    title: 'Email',
    dataKey: 'email',
    render: (title: string) => (
      <Text variant="ellipsis">
        {title}
      </Text>
    ),
  },
  {
    title: 'Phone',
    dataKey: 'phone',
    render: (phone: string) => (
      <Text variant="ellipsis">
        {phone}
      </Text>
    ),
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      textAlign: 'center',
    },
    render: (id: number) => (
      <AgenciesTableActions agencyId={id} />
    ),
  },
]

interface AgenciesTableProps {
  agencies: AgencyModel[],
}

const AgenciesTable = (props: AgenciesTableProps) => {
  const { agencies } = props

  const memoColumns = useMemo(() => buildColumns(), [agencies.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      // @ts-expect-error TS2322
      data={agencies}
      // @ts-expect-error TS2322
      scroll={{ x: '100%' }}
      stickyHeader
    />
  )
}

export default memo(AgenciesTable)
